import { render, staticRenderFns } from "./OrderLineAllowanceCharge.vue?vue&type=template&id=a1262eb2&scoped=true&"
import script from "./OrderLineAllowanceCharge.vue?vue&type=script&lang=ts&"
export * from "./OrderLineAllowanceCharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1262eb2",
  null
  
)

export default component.exports